<template>
  <label>
    Metal Type
    <select :value="value" class="font16" @input="$emit('input', $event.target.value)" id="metal_type_select">
      <template v-if="authenticated && activeShop">
        <option disabled selected value />
        <option
          v-for="(metal, index) in metalTypes"
          :key="index"
          :value="metal"
        >
          {{ metal }}
        </option>
      </template>
      <option v-if="!authenticated" disabled selected value>Sign in required</option>
      <option v-if="!activeShop" disabled selected value>Shop Closed</option>
    </select>
  </label>
</template>

<script>
export default {
  props: {
    authenticated: {
      type: Boolean,
      required: true
    },
    activeShop: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      metalTypes: [
        "Alloy Steel",
        "Aluminum",
        "Carbon Steel",
        "Cobalt Chrome Moly",
        "Nickel Alloy",
        "Stainless Steel",
        "Titanium"
      ]
    };
  }
};
</script>
